<div class="dropdown">
  @for (role of roles(); track role.id) {
    <button
      class="dropdown-item"
      [class.selected]="selectedRoleId() === role.name"
      (mousedown)="selectRole(role)"
    >
      {{ role.name }}

      @if (selectedRoleId() === role.name) {
        <app-icon class="check-icon" [icon]="IconName.PURPLE_CHECK" />
      }
    </button>
  }
</div>
